// FamilyHistoryCard.jsx

import React, { useEffect, useState } from "react";
import { FiHeart } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import { useParams } from "react-router-dom";
import moment from "moment";

import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";

const FamilyHistoryCard = ({ onExportData }) => {
  const params = useParams();

  const [familyHistory, setFamilyHistory] = useState([]);

  useEffect(() => {
    if (params?.pid) {
      let load_data = "limit=10&offset=0&pid=" + params.pid;

      let load_data_enc = Encrypt_Value(load_data, "vozo");

      axiosInstance
        .get("/vozo/famhis?search=" + load_data_enc)
        .then((response) => {
          let data = Decrypt_Value(response.data, "vozo");

          setFamilyHistory(data || []);

          if (onExportData) {
            onExportData(
              (data || []).map((item) => ({
                observation: item.observation || "-",
                relationship: item.relationship || "-",
                age: item.age || "-",
                created_at: item.created_at || "-",
              })),
            );
          }
        })
        .catch((err) => {
          console.error(err.message);
          setFamilyHistory([]);
        });
    }
  }, [params.pid]);

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiHeart className="care-summary-main-icon" />

        <h3 className="care-summary-title">Family History</h3>
      </div>

      <div className="care-summary-body">
        {familyHistory.length > 0 ? (
          familyHistory.slice(0, 3).map((item, index) => (
            <div
              key={item.id || index}
              className={`care-summary-row-column ${
                index !== familyHistory.length - 1 ? "care-summary-border" : ""
              }`}
            >
              <div className="care-summary-heading">
                {item.observation || "—"}
              </div>

              <div className="care-summary-subtext dark-sub">
                {item.relationship
                  ? item.relationship.charAt(0).toUpperCase() +
                    item.relationship.slice(1).toLowerCase()
                  : "—"}

                {item.age ? ` - age ${item.age}` : ""}
              </div>

              <div className="care-summary-subtext">
                Documented:{" "}
                {item.created_at
                  ? moment(item.created_at).format("MMM DD, YYYY")
                  : "—"}
              </div>
            </div>
          ))
        ) : (
          <div className="care-summary-subtext">No Family History Added</div>
        )}
      </div>
    </div>
  );
};

export default React.memo(FamilyHistoryCard);
